import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BaseDetailScreen from '../BaseDetailScreen';
import Currency from '../Currency';
import Percentage from '../Percentage';
import ValueChart, { CHART_TYPE, OPT_1D } from '../Portfolio/ValueChart';
import Button from '../Button';
import { TRADE_TYPE } from '../SecurityTrade';

import './SecurityDetail.css';

const BoxItemCurr = ({ head, value }) => (
  <div styleName="boxedInfo">
    <div styleName="boxedHead">{head}</div>
    <Currency styleName="boxedValue" amount={value} />
  </div>
);

const DetItemCurr = ({ head, value }) => (
  <div styleName="addDetItem">
    <div styleName="addDetText">{head}</div>
    <Currency styleName="addDetText" amount={value} />
  </div>
);

export const formatQuantity = (amount) => {
  let displayString = '--';

  if (Number.isFinite(amount)) {
    displayString = amount.toLocaleString('en-US', {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  return displayString;
};

class SecurityDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAdditional: false,
    };
  }
  render() {
    const {
      chartValues,
      security,
      chartDetailValues,
      onRangeChange,
      isChartDataLoading,
    } = this.props;
    const { showAdditional } = this.state;
    return (
      <div>
        <BaseDetailScreen
          pageHeading={security.name}
          backTo="/portfolio"
          backLabel="Summary"
        >
          <div styleName="detail">
            <Currency styleName="currencyLarge" amount={security.currentPrice} />
            <Percentage style={{ width: '100%', textAlign: 'center', fontSize: 20 }} amount={security.currentChange} />
            <div>
              <ValueChart
                chartType={CHART_TYPE.SECURITY}
                values={chartValues}
                detailValues={chartDetailValues}
                onRangeChange={onRangeChange}
                isChartDataLoading={isChartDataLoading}
                initialRange={OPT_1D}
              />
            </div>
            <div>
              <div styleName="boxedRowTop">
                <BoxItemCurr head="Purchase Price" value={security.purchasePrice} />
                <div styleName="boxedInfo">
                  <div styleName="boxedHead">Quantity</div>
                  <div styleName="boxedValue">{formatQuantity(Number.parseFloat(security.quantity))}</div>
                </div>
              </div>
              <div styleName="boxedRowBtm">
                <BoxItemCurr head="Cost" value={security.cost} />
                <BoxItemCurr head="Value" value={security.value} />
              </div>
              <input
                id="addDet"
                type="button"
                key="addDet"
                styleName="addDetailBtn"
                onClick={() => this.setState({
                  ...this.state,
                  showAdditional: !this.state.showAdditional,
                })}
                value={showAdditional ? '- Fewer Details' : '+ Additional Details'}
              />
              {showAdditional ?
                <div styleName="addDetRow">
                  <div styleName="addDetCol">
                    <DetItemCurr head="Day High" value={security.dayHigh} />
                    <DetItemCurr head="Day Low" value={security.dayLow} />
                    <DetItemCurr head="Open Price" value={security.openPrice} />
                  </div>
                  <div styleName="addDetCol">
                    <div styleName="addDetItem">
                      <div styleName="addDetText">Change</div>
                      <Percentage style={{ fontSize: 18 }} amount={security.changepercent} />
                    </div>
                    <DetItemCurr head="Bid" value={security.bid} />
                    <DetItemCurr head="Ask" value={security.ask} />
                  </div>
                  <div styleName="addDetCol">
                    <DetItemCurr head="52 Week High" value={security.fiftyTwoWeekHigh} />
                    <DetItemCurr head="52 Week Low" value={security.fiftyTwoWeekLow} />
                    <div styleName="addDetItem">
                      <div styleName="addDetText">Volume</div>
                      <div styleName="addDetText">{formatQuantity(security.sharevolume)}
                      </div>
                    </div>
                  </div>
                </div> : null}
            </div>
            <div styleName="btnRow">
              <Button className="btnAct" to={`/security-trade/${security.securityId}/${TRADE_TYPE.BUY}`}>
                <div styleName="btn">Buy</div>
              </Button>
              <div styleName="filler" />
              <Button to={`/security-trade/${security.securityId}/${TRADE_TYPE.SELL}`}>
                <div styleName="btn">Sell</div>
              </Button>
            </div>
          </div>
        </BaseDetailScreen>
      </div>
    );
  }
}

SecurityDetail.propTypes = {
  chartValues: PropTypes.arrayOf(PropTypes.shape({})),
  chartDetailValues: PropTypes.arrayOf(PropTypes.shape({})),
  onRangeChange: PropTypes.func,
  isChartDataLoading: PropTypes.bool,
  security: PropTypes.shape({
    name: PropTypes.string,
    currentPrice: PropTypes.number,
    currentChange: PropTypes.number,
    purchasePrice: PropTypes.number,
    quantity: PropTypes.number,
    cost: PropTypes.number,
    value: PropTypes.number,
    dayHigh: PropTypes.number,
    dayLow: PropTypes.number,
    openPrice: PropTypes.number,
    changepercent: PropTypes.number,
    bid: PropTypes.number,
    ask: PropTypes.number,
    fiftyTwoWeekHigh: PropTypes.number,
    fiftyTwoWeekLow: PropTypes.number,
    volume: PropTypes.number,
  }),
};

SecurityDetail.defaultProps = {
  chartValues: [{}],
  chartDetailValues: [{}],
  onRangeChange: () => {},
  isChartDataLoading: false,
  security: {
    name: 'Not Found',
    currentPrice: null,
    currentChange: null,
    purchasePrice: null,
    quantity: null,
    cost: null,
    value: null,
    dayHigh: null,
    dayLow: null,
    openPrice: null,
    changepercent: null,
    bid: null,
    ask: null,
    fiftyTwoWeekHigh: null,
    fiftyTwoWeekLow: null,
    volume: null,
  },
};

export default SecurityDetail;



// WEBPACK FOOTER //
// ./src/components/SecurityDetail/SecurityDetail.js